(function () {
    "use strict";

    var app = angular.module("iMatApp");

    var eventNames = {
        menuItemOpened: 'MenuItemOpened',
        showBrowseFileDialog: 'showBrowseFileDialog'
    };
    
    app.constant("uploadModelConsts", {
        eventNames: eventNames
    });
})();